<template>
  <div>
    <el-drawer title="历史记录" :visible.sync="drawer" :append-to-body="true" custom-class="pop-history" :show-close="false" size="640px" direction="rtl">
      <div class="history-order">
        <el-dropdown @command="toggleOrder" trigger="click">
          <span class="el-dropdown-link hand">
            {{ orderTitle }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">按记录时间顺序</el-dropdown-item>
            <el-dropdown-item command="2">按记录时间倒序</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="history-list">
        <div v-for="(item, index) in timeline" :key="index" class="item-history">
          <div class="photo">
            <div :class="'i-status i-' + item.changeType"></div>
          </div>
          <!-- 创建 -->
          <div class='con'>
            <div class="title-con">
              <div>
                <span class="title">{{ item.changeTypeLabel }}</span>
                <span class="name">{{ item.createdByDeptName }} {{ item.createdByName }}</span>
              </div>
              <!-- 2转移 -->
              <div v-if="item.changeType == 2 && item.actProcInstId">
                <el-button type="primary" class="btn-look" @click="onApproveDetail(item.actProcInstId)" plain size="mini">审批详情</el-button>
              </div>
            </div>
            <div class="time">{{ item.createdTime }}</div>
            <!--  // 1创建-->
            <template v-if="item.changeType == 1">
              <!-- 工作手机号 -->
              <div v-if="item.phoneData" class="content clearfix" :class="{ 'content-open': item.show }">
                <div class="row">
                  <div class='col'>创建时间：{{ item.phoneData.createdTime }}</div>
                  <div class='col'>创建人：{{ item.phoneData.createdByName }}</div>
                </div>
                <div class="row">
                  <div class='col'>手机号：{{ item.phoneData.phone }}</div>
                  <div class='col'>实名人：{{ item.phoneData.name }}</div>
                </div>
                <div class="more-con">
                  <div>运营商：{{ item.phoneData.phoneOperatorLabel }}</div>
                  <div>手机号备注：{{ item.phoneData.remarks }}</div>
                </div>
                <div class="btn-more" @click="toggleMore(index)">
                  {{ item.show ? '收起' : '展开' }}
                  <i class="icon el-icon-d-arrow-right"></i>
                </div>
              </div>
              <!-- 工作微信号 -->
               <div v-if="item.wechatData" class="content clearfix" :class="{ 'content-open': item.show }">
                <div class="row">
                  <div class='col'>创建时间：{{ item.wechatData.createdTime }}</div>
                  <div class='col'>创建人：{{ item.wechatData.createdByName }}</div>
                </div>
                <div class="row">
                  <div class='col'>微信号：{{ item.wechatData.account }}</div>
                  <div class='col'>微信号密码：
                      <span @click="onEye(index,item,item.wechatData.password)" :class="[item.myPassword?'eye-con':'eye-con-hide']" >
                        <span class="text">{{item.myPassword}}</span>
                        <span class="default">******</span>
                        <i class="i-eye"></i>
                      </span>
                  </div>
                </div>
                <div class="more-con">
                  <div>微信号实名人：{{ item.wechatData.name }}</div>
                  <div>微信号绑定手机号：{{ item.wechatData.phone }}</div>
                  <div>绑定手机号员工：{{ item.wechatData.phoneOwner }}</div>
                  <div>微信好友数：{{ item.wechatData.friendsCount || 0 }}</div>
                  <div>微信号备注：{{ item.wechatData.remarks }}</div>
                </div>
                <div class="btn-more" @click="toggleMore(index)">
                  {{ item.show ? '收起' : '展开' }}
                  <i class="icon el-icon-d-arrow-right"></i>
                </div>
              </div>
              <!-- 工作QQ号 -->
              <div v-if="item.qqData" class="content clearfix" :class="{ 'content-open': item.show }">
                <div class="row">
                  <div class='col'>创建时间：{{ item.qqData.createdTime }}</div>
                  <div class='col'>创建人：{{ item.qqData.createdByName }}</div>
                </div>
                <div class="row">
                  <div class='col'>QQ号：{{ item.qqData.account }}</div>
                  <div class='col'>QQ号密码：
                      <span @click="onEye(index,item,item.qqData.password)" :class="[item.myPassword?'eye-con':'eye-con-hide']" >
                        <span class="text">{{item.myPassword}}</span>
                        <span class="default">******</span>
                        <i class="i-eye"></i>
                      </span>
                  </div>
                </div>
                <div class="more-con">
                  <div>QQ号实名人：{{ item.qqData.name }}</div>
                  <div>QQ号绑定手机号：{{ item.qqData.phone }}</div>
                  <div>绑定手机号员工：{{ item.qqData.phoneOwner }}</div>
                  <div>QQ好友数：{{ item.qqData.friendsCount || 0 }}</div>
                  <div>QQ号备注：{{ item.qqData.remarks }}</div>
                </div>
                <div class="btn-more" @click="toggleMore(index)">
                  {{ item.show ? '收起' : '展开' }}
                  <i class="icon el-icon-d-arrow-right"></i>
                </div>
              </div>
              <!-- 工作邮箱号 -->
              <div v-if="item.emailData" class="content clearfix" :class="{ 'content-open': item.show }">
                <div class="row">
                  <div class='col'>创建时间：{{ item.emailData.createdTime }}</div>
                  <div class='col'>创建人：{{ item.emailData.createdByName }}</div>
                </div>
                <div class="row">
                  <div class='col'>工作邮箱：{{ item.emailData.account }}</div>
                  <div class='col'>邮箱密码：
                      <span @click="onEye(index,item,item.emailData.password)" :class="[item.myPassword?'eye-con':'eye-con-hide']" >
                        <span class="text">{{item.myPassword}}</span>
                        <span class="default">******</span>
                        <i class="i-eye"></i>
                      </span>
                  </div>
                </div>
                <div class="more-con">
                  <div>邮箱实名人：{{ item.emailData.name }}</div>
                  <div>邮箱绑定手机号：{{ item.emailData.phone }}</div>
                  <div>绑定手机号员工：{{ item.emailData.phoneOwner }}</div>
                  <div>邮箱备注：{{ item.emailData.remarks }}</div>
                </div>
                <div class="btn-more" @click="toggleMore(index)">
                  {{ item.show ? '收起' : '展开' }}
                  <i class="icon el-icon-d-arrow-right"></i>
                </div>
              </div>
              <!-- 平台账号 新增 -->
              <div v-if="item.platformData" class="content clearfix" :class="{ 'content-open': item.show }">
                <div class="row">
                  <div class='col'>创建时间：{{ item.platformData.createdTime }}</div>
                  <div class='col'>创建人：{{ item.platformData.createdByName }}</div>
                </div>
                <div>主账号使用状态：{{ item.platformData.usingStatus==1?'使用中':'已停用'}}</div>
                <div>登录网址：{{ item.platformData.loginUrl }}</div>
                <div class="more-con">
                  <div>是否有子账号：{{ item.platformData.hasSubsidiary==0?'否':'是' }}</div>
                  <div>所属平台：{{ item.platformData.platformName }}</div>
                  <div>注册形式：{{ item.platformData.regType==1?'公司':'个人' }}</div>
                  <template v-if="item.platformData.regType==1">
                      <div>公司主体：{{ item.platformData.companyName }}</div>
                      <div>法人/经营人：{{ item.platformData.legalPerson }}</div>
                  </template>
                  <div>账号名称：{{ item.platformData.accountName }}</div>
                  <!-- 主账号 -->
                  <div class="line"></div>
                  <div class="title-text">主账号</div>
                  <div>登录账号：{{ item.platformData.mainAccount.account }}</div>
                  <div>账号密码：
                    <span @click="onEyeAccount('main',index,item,item.platformData.mainAccount.password)" :class="[item.myPassword?'eye-con':'eye-con-hide']" >
                      <span class="text">{{item.myPassword}}</span>
                      <span class="default">******</span>
                      <i class="i-eye"></i>
                    </span>
                  </div>
                  <div>账号使用人：{{ item.platformData.mainAccount.usingUserNameList && item.platformData.mainAccount.usingUserNameList.toString() }}</div>
                  <div class="row">
                    <div class='col'>账号绑定手机号：{{ item.platformData.mainAccount.phone }}</div>
                    <div class='col'>绑定手机号员工：{{ item.platformData.mainAccount.phoneOwnerName }}</div>
                  </div>
                  <div class="row">
                    <div class='col'>账号绑定微信号：{{ item.platformData.mainAccount.wechat }}</div>
                    <div class='col'>绑定微信号员工：{{ item.platformData.mainAccount.wechatOwnerName }}</div>
                  </div>
                  <div class="row">
                    <div class='col'>账号绑定QQ号：{{ item.platformData.mainAccount.qq }}</div>
                    <div class='col'>绑定QQ号员工：{{ item.platformData.mainAccount.qqOwnerName }}</div>
                  </div>
                  <div class="row">
                    <div class='col'>账号绑定邮箱：{{ item.platformData.mainAccount.email }}</div>
                    <div class='col'>绑定邮箱员工：{{ item.platformData.mainAccount.emailOwnerName }}</div>
                  </div>
                  <div>是否有ID：{{ item.platformData.mainAccount.hasId==0?'否':'是' }}</div>
                  <template v-if="item.platformData.mainAccount.hasId==1">
                    <div v-for="(accountIdItem,index2) in item.platformData.mainAccount.accountIdList" :key="index+'-'+index2">
                      <div class="row">
                        <div class='col'>账号ID({{ makeIndex(index2) }})：{{ accountIdItem.accountId }}</div>
                        <div class='col'>所属五域类目：{{ accountIdItem.categoryName }}</div>
                      </div>
                      <div class="row">
                        <div class='col'>渠道号：{{ accountIdItem.channelName }}</div>
                        <div class='col'>ID使用状态：{{ accountIdItem.status==1?'开启':'停用' }}</div>
                      </div>
                    </div>
                  </template>
                  <!-- 子账号 -->
                  <template v-if="item.platformData.hasSubsidiary==1 && item.platformData.subAccountList.length>0">
                    <div class="line"></div>
                    <div v-for="(subAccountItem,subIndex) of item.platformData.subAccountList" :key="subIndex">
                      <div class="title-text">子账号({{ makeIndex(subIndex) }})</div>
                      <div>登录账号：{{ subAccountItem.account }}</div>
                      <div>账号密码：
                        <span  @click="onEyeAccount('sub',index,item,subAccountItem.password,subIndex)" :class="[subAccountItem.myPassword?'eye-con':'eye-con-hide']" >
                          <span class="text">{{subAccountItem.myPassword}}</span>
                          <span class="default">******</span>
                          <i class="i-eye"></i>
                        </span>
                      </div>
                      <div>账号使用人：{{ subAccountItem.usingUserNameList && subAccountItem.usingUserNameList.toString() }}</div>
                      <div class="row">
                        <div class='col'>账号绑定手机号：{{ subAccountItem.phone }}</div>
                        <div class='col'>绑定手机号员工：{{ subAccountItem.phoneOwnerName }}</div>
                      </div>
                      <div class="row">
                        <div class='col'>账号绑定微信号：{{ subAccountItem.wechat }}</div>
                        <div class='col'>绑定微信号员工：{{ subAccountItem.wechatOwnerName }}</div>
                      </div>
                      <div class="row">
                        <div class='col'>账号绑定QQ号：{{ subAccountItem.qq }}</div>
                        <div class='col'>绑定QQ号员工：{{ subAccountItem.qqOwnerName }}</div>
                      </div>
                      <div class="row">
                        <div class='col'>账号绑定邮箱：{{ subAccountItem.email }}</div>
                        <div class='col'>绑定邮箱员工：{{ subAccountItem.emailOwnerName }}</div>
                      </div>
                      <div>是否有ID：{{ subAccountItem.hasId==0?'否':'是' }}</div>
                      <template v-if="subAccountItem.hasId==1">
                        <div v-for="(subAccountIdItem,index3) in subAccountItem.accountIdList" :key="subIndex+'-'+index3">
                          <div class="row">
                            <div class='col'>账号ID({{ makeIndex(index3) }})：{{ subAccountIdItem.accountId }}</div>
                            <div class='col'>所属五域类目：{{ subAccountIdItem.categoryName }}</div>
                          </div>
                          <div class="row">
                            <div class='col'>渠道号：{{ subAccountIdItem.channelName }}</div>
                            <div class='col'>ID使用状态：{{ subAccountIdItem.status==1?'开启':'停用' }}</div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </template>
                  <div class="line"></div>
                  <div class="title-text">其他信息</div>
                  <div>是否有店铺：{{ item.platformData.hasShop==0?'否':'是' }}</div>
                  <template v-if="item.platformData.hasShop==1">
                    <div v-for="(shopItem,shopIndex) in item.platformData.shopList" :key="'shop-'+shopIndex">
                      <div>店铺{{ makeIndex(shopIndex) }}名称：{{ shopItem.shopName }}</div>
                      <div class="row">
                        <div class='col'>店铺{{ makeIndex(shopIndex) }}ID：{{ shopItem.shopId }}</div>
                        <div class='col'>店铺{{ makeIndex(shopIndex) }}状态：{{ shopItem.status==1?'开启':'停用' }}</div>
                      </div>
                    </div>
                  </template>
                  <div>平台账号备注：{{ item.platformData.remarks }}</div>
                </div>
                <div class="btn-more" @click="toggleMore(index)">
                  {{ item.show ? '收起' : '展开' }}
                  <i class="icon el-icon-d-arrow-right"></i>
                </div>
              </div>
            </template>
            <!--  //3修改 -->
            <template v-if="item.changeType == 3">
              <!-- 工作手机号 -->
              <div v-if="item.phoneData" class="content clearfix" :class="{ 'content-open': item.show }">
                <div class="row">
                  <div class='col'>更新时间：{{ item.phoneData.updatedTime }}</div>
                  <div class='col' :class="setMark(item, 'ownerUserName')">最后归属人：{{ item.phoneData.ownerUserName }}</div>
                </div>
                <div class="row">
                  <div class='col'>手机号状态:
                    <span v-if="item.phoneData.statusLabel" :class="'icon-status icon-status-' + item.phoneData.status"> {{ item.phoneData.statusLabel }}</span>
                  </div>
                  <div class='col' :class="setMark(item, 'phone')">手机号：{{ item.phoneData.phone }}</div>
                </div>
                <div class="row">
                  <div class='col' :class="setMark(item, 'name')">实名人：{{ item.phoneData.name }}</div>
                </div>
                <div class="more-con">
                  <div :class="setMark(item, 'phoneOperator')">运营商：{{ item.phoneData.phoneOperatorLabel }}</div>
                  <div :class="setMark(item, 'remark')">手机号备注：{{ item.phoneData.remarks }}</div>
                </div>
                <div class="btn-more" @click="toggleMore(index)">
                  {{ item.show ? '收起' : '展开' }}
                  <i class="icon el-icon-d-arrow-right"></i>
                </div>
              </div>
              <!-- 工作微信号 -->
              <div v-if="item.wechatData" class="content clearfix" :class="{ 'content-open': item.show }">
                <div class="row">
                  <div class='col'>更新时间：{{ item.wechatData.updatedTime }}</div>
                  <div class='col' :class="setMark(item, 'ownerUserName')">最后归属人：{{ item.wechatData.ownerUserName }}</div>
                </div>
                <div class="row">
                  <div class='col'>微信号状态:
                    <span v-if="item.wechatData.statusLabel" :class="'icon-status icon-status-' + item.wechatData.status"> {{ item.wechatData.statusLabel }}</span>
                  </div>
                  <div class='col' :class="setMark(item, 'account')">微信号：{{ item.wechatData.account }}</div>
                </div>
                <div class="row">
                  <div class='col' :class="setMark(item, 'password')">微信号密码：
                      <span @click="onEye(index,item,item.wechatData.password)" :class="[item.myPassword?'eye-con':'eye-con-hide']" >
                        <span class="text">{{item.myPassword}}</span>
                        <span class="default">******</span>
                        <i class="i-eye"></i>
                      </span>
                  </div>
                </div>
                <div class="more-con">
                  <div :class="setMark(item, 'name')">微信号实名人：{{ item.wechatData.name }}</div>
                  <div :class="setMark(item, 'phone')">微信号绑定手机号：{{ item.wechatData.phone }}</div>
                  <div :class="setMark(item, 'phoneOwnerUserId')">绑定手机号员工：{{ item.wechatData.phoneOwner }}</div>
                  <div :class="setMark(item, 'friendsCount')">微信好友数：{{ item.wechatData.friendsCount  || 0}}</div>
                  <div :class="setMark(item, 'remark')">微信号备注：{{ item.wechatData.remarks }}</div>
                </div>
                <div class="btn-more" @click="toggleMore(index)">
                  {{ item.show ? '收起' : '展开' }}
                  <i class="icon el-icon-d-arrow-right"></i>
                </div>
              </div>
              <!-- 工作QQ号 -->
              <div v-if="item.qqData" class="content clearfix" :class="{ 'content-open': item.show }">
                <div class="row">
                  <div class='col'>更新时间：{{ item.qqData.updatedTime }}</div>
                  <div class='col' :class="setMark(item, 'ownerUserName')">最后归属人：{{ item.qqData.ownerUserName }}</div>
                </div>
                <div class="row">
                  <div class='col'>QQ号状态:
                    <span v-if="item.qqData.statusLabel" :class="'icon-status icon-status-' + item.qqData.status"> {{ item.qqData.statusLabel }}</span>
                  </div>
                  <div class='col' :class="setMark(item, 'account')">QQ号：{{ item.qqData.account }}</div>
                </div>
                <div class="row">
                  <div class='col' :class="setMark(item, 'password')">QQ号密码：
                      <span @click="onEye(index,item,item.qqData.password)" :class="[item.myPassword?'eye-con':'eye-con-hide']" >
                        <span class="text">{{item.myPassword}}</span>
                        <span class="default">******</span>
                        <i class="i-eye"></i>
                      </span>
                  </div>
                </div>
                <div class="more-con">
                  <div :class="setMark(item, 'name')">QQ号实名人：{{ item.qqData.name }}</div>
                  <div :class="setMark(item, 'phone')">QQ号绑定手机号：{{ item.qqData.phone }}</div>
                  <div :class="setMark(item, 'phoneOwnerUserId')">绑定手机号员工：{{ item.qqData.phoneOwner }}</div>
                  <div :class="setMark(item, 'friendsCount')">QQ好友数：{{ item.qqData.friendsCount || 0}}</div>
                  <div :class="setMark(item, 'remark')">QQ号备注：{{ item.qqData.remarks }}</div>
                </div>
                <div class="btn-more" @click="toggleMore(index)">
                  {{ item.show ? '收起' : '展开' }}
                  <i class="icon el-icon-d-arrow-right"></i>
                </div>
              </div>
              <!-- 工作邮箱号 -->
              <div v-if="item.emailData" class="content clearfix" :class="{ 'content-open': item.show }">
                <div class="row">
                  <div class='col'>更新时间：{{ item.emailData.updatedTime }}</div>
                  <div class='col' :class="setMark(item, 'ownerUserName')">最后归属人：{{ item.emailData.ownerUserName }}</div>
                </div>
                <div class="row">
                  <div class='col'>邮箱状态:
                    <span v-if="item.emailData.statusLabel" :class="'icon-status icon-status-' + item.emailData.status"> {{ item.emailData.statusLabel }}</span>
                  </div>
                  <div class='col' :class="setMark(item, 'account')">工作邮箱：{{ item.emailData.account }}</div>
                </div>
                <div class="row">
                  <div class='col' :class="setMark(item, 'password')">邮箱密码：
                      <span @click="onEye(index,item,item.emailData.password)" :class="[item.myPassword?'eye-con':'eye-con-hide']" >
                        <span class="text">{{item.myPassword}}</span>
                        <span class="default">******</span>
                        <i class="i-eye"></i>
                      </span>
                  </div>
                </div>
                <div class="more-con">
                  <div :class="setMark(item, 'name')">邮箱实名人：{{ item.emailData.name }}</div>
                  <div :class="setMark(item, 'hasPhone')">是否绑定手机号：{{ item.emailData.hasPhone?'是':'否' }}</div>
                  <template v-if="item.emailData.hasPhone">
                    <div :class="setMark(item, 'phone')">邮箱绑定手机号：{{ item.emailData.phone }}</div>
                    <div :class="setMark(item, 'phone')">绑定手机号员工：{{ item.emailData.phoneOwner }}</div>  
                  </template>
                  <div :class="setMark(item, 'remark')">邮箱备注：{{ item.emailData.remarks }}</div>
                </div>
                <div class="btn-more" @click="toggleMore(index)">
                  {{ item.show ? '收起' : '展开' }}
                  <i class="icon el-icon-d-arrow-right"></i>
                </div>
              </div>
              <!-- 平台账号 修改-->
              <div v-if="item.platformData" class="content clearfix" :class="{ 'content-open': item.show }">
                <div class="row">
                  <div class='col'>更新时间：{{ item.platformData.createdTime }}</div>
                  <div class='col' :class="setMark(item, 'ownerUserName',item.platformData.id)" >最后归属人：{{ item.platformData.ownerUserName }}</div>
                </div>
                <div :class="setMark(item, 'usingStatus',item.platformData.id)" >主账号使用状态：{{ item.platformData.usingStatus==1?'使用中':'已停用' }}</div>
                <div :class="setMark(item, 'loginUrl',item.platformData.id)">登录网址：{{ item.platformData.loginUrl }}</div>
                <div class="more-con">
                  <div :class="setMark(item, 'hasSubsidiary',item.platformData.id)">是否有子账号：{{ item.platformData.hasSubsidiary==0?'否':'是' }}</div>
                  <div :class="setMark(item, 'platformKey',item.platformData.id)">所属平台：{{ item.platformData.platformName }}</div>
                  <div :class="setMark(item, 'regType',item.platformData.id)">注册形式：{{ item.platformData.regType==1?'公司':'个人' }}</div>
                  <template v-if="item.platformData.regType==1">
                      <div :class="setMark(item, 'companyName',item.platformData.id)">公司主体：{{ item.platformData.companyName }}</div>
                      <div :class="setMark(item, 'legalPerson',item.platformData.id)">法人/经营人：{{ item.platformData.legalPerson }}</div>
                  </template>
                  <div :class="setMark(item, 'accountName',item.platformData.id)">账号名称：{{ item.platformData.accountName }}</div>
                  <!-- 主账号 -->
                  <div class="line"></div>
                  <div class="title-text">主账号</div>
                  <div :class="setMark(item, 'account',item.platformData.mainAccount.id)">登录账号：{{ item.platformData.mainAccount.account }}</div>
                  <div :class="setMark(item, 'password',item.platformData.mainAccount.id)">账号密码：
                    <span @click="onEyeAccount('main',index,item,item.platformData.mainAccount.password)" :class="[item.myPassword?'eye-con':'eye-con-hide']" >
                      <span class="text">{{item.myPassword}}</span>
                      <span class="default">******</span>
                      <i class="i-eye"></i>
                    </span>
                  </div>
                  <div :class="setMark(item, 'usingUserIdList',item.platformData.mainAccount.id)">账号使用人：{{ item.platformData.mainAccount.usingUserNameList && item.platformData.mainAccount.usingUserNameList.toString() }}</div>
                  <div class="row">
                    <div class='col' :class="setMark(item, 'phone',item.platformData.mainAccount.id)">账号绑定手机号：{{ item.platformData.mainAccount.phone }}</div>
                    <div class='col' :class="setMark(item, 'phoneOwnerName',item.platformData.mainAccount.id)">绑定手机号员工：{{ item.platformData.mainAccount.phoneOwnerName }}</div>
                  </div>
                  <div class="row">
                    <div class='col' :class="setMark(item, 'wechat',item.platformData.mainAccount.id)">账号绑定微信号：{{ item.platformData.mainAccount.wechat }}</div>
                    <div class='col' :class="setMark(item, 'wechatOwnerName',item.platformData.mainAccount.id)">绑定微信号员工：{{ item.platformData.mainAccount.wechatOwnerName }}</div>
                  </div>
                  <div class="row">
                    <div class='col' :class="setMark(item, 'qq',item.platformData.mainAccount.id)">账号绑定QQ号：{{ item.platformData.mainAccount.qq }}</div>
                    <div class='col' :class="setMark(item, 'qqOwnerName',item.platformData.mainAccount.id)">绑定QQ号员工：{{ item.platformData.mainAccount.qqOwnerName }}</div>
                  </div>
                  <div class="row">
                    <div class='col' :class="setMark(item, 'email',item.platformData.mainAccount.id)">账号绑定邮箱：{{ item.platformData.mainAccount.email }}</div>
                    <div class='col' :class="setMark(item, 'emailOwnerName',item.platformData.mainAccount.id)">绑定邮箱员工：{{ item.platformData.mainAccount.emailOwnerName }}</div>
                  </div>
                  <div :class="setMark(item, 'hasId',item.platformData.mainAccount.id)">是否有ID：{{ item.platformData.mainAccount.hasId==0?'否':'是' }}</div>
                  <template v-if="item.platformData.mainAccount.hasId==1">
                    <div v-for="(accountIdItem,index2) in item.platformData.mainAccount.accountIdList" :key="index+'-'+index2">
                      <div class="row">
                        <div class='col' :class="setMark(item, 'accountId',accountIdItem.id)">账号ID({{ makeIndex(index2) }})：{{ accountIdItem.accountId }}</div>
                        <div class='col' :class="setMark(item, 'categoryId',accountIdItem.id)">所属五域类目：{{ accountIdItem.categoryName }}</div>
                      </div>
                      <div class="row">
                        <div class='col' :class="setMark(item, 'channelName',accountIdItem.id)">渠道号：{{ accountIdItem.channelName }}</div>
                        <div class='col' :class="setMark(item, 'status',accountIdItem.id)">ID使用状态：{{ accountIdItem.status==1?'开启':'停用' }}</div>
                      </div>
                    </div>
                  </template>
                  <!-- 子账号 -->
                  <template v-if="item.platformData.hasSubsidiary==1 && item.platformData.subAccountList.length>0">
                    <div v-for="(subAccountItem,subIndex) of item.platformData.subAccountList" :key="subIndex">
                      <div class="line"></div>
                      <div class="title-text">子账号({{ makeIndex(subIndex) }})</div>
                      <div :class="setMark(item, 'account',subAccountItem.id)">登录账号：{{ subAccountItem.account }}</div>
                      <div :class="setMark(item, 'password',subAccountItem.id)">账号密码：
                        <span  @click="onEyeAccount('sub',index,item,subAccountItem.password,subIndex)" :class="[subAccountItem.myPassword?'eye-con':'eye-con-hide']" >
                          <span class="text">{{subAccountItem.myPassword}}</span>
                          <span class="default">******</span>
                          <i class="i-eye"></i>
                        </span>
                      </div>
                      <div :class="setMark(item, 'usingUserIdList',subAccountItem.id)">账号使用人：{{ subAccountItem.usingUserNameList && subAccountItem.usingUserNameList.toString() }}</div>
                      <div class="row">
                        <div class='col' :class="setMark(item, 'phone',subAccountItem.id)">账号绑定手机号：{{ subAccountItem.phone }}</div>
                        <div class='col' :class="setMark(item, 'phoneOwnerName',subAccountItem.id)">绑定手机号员工：{{ subAccountItem.phoneOwnerName }}</div>
                      </div>
                      <div class="row">
                        <div class='col' :class="setMark(item, 'wechat',subAccountItem.id)">账号绑定微信号：{{ subAccountItem.wechat }}</div>
                        <div class='col' :class="setMark(item, 'wechatOwnerName',subAccountItem.id)">绑定微信号员工：{{ subAccountItem.wechatOwnerName }}</div>
                      </div>
                      <div class="row">
                        <div class='col' :class="setMark(item, 'qq',subAccountItem.id)">账号绑定QQ号：{{ subAccountItem.qq }}</div>
                        <div class='col' :class="setMark(item, 'qqOwnerName',subAccountItem.id)">绑定QQ号员工：{{ subAccountItem.qqOwnerName }}</div>
                      </div>
                      <div class="row">
                        <div class='col' :class="setMark(item, 'email',subAccountItem.id)">账号绑定邮箱：{{ subAccountItem.email }}</div>
                        <div class='col' :class="setMark(item, 'emailOwnerName',subAccountItem.id)">绑定邮箱员工：{{ subAccountItem.emailOwnerName }}</div>
                      </div>
                      <div :class="setMark(item, 'hasId',subAccountItem.id)">是否有ID：{{ subAccountItem.hasId==0?'否':'是' }}</div>
                      <template v-if="subAccountItem.hasId==1">
                        <div v-for="(subAccountIdItem,index3) in subAccountItem.accountIdList" :key="subIndex+'-'+index3">
                          <div class="row">
                            <div class='col' :class="setMark(item, 'accountId',subAccountIdItem.id)">账号ID({{ makeIndex(index3) }})：{{ subAccountIdItem.accountId }}</div>
                            <div class='col' :class="setMark(item, 'categoryId',subAccountIdItem.id)">所属五域类目：{{ subAccountIdItem.categoryName }}</div>
                          </div>
                          <div class="row">
                            <div class='col' :class="setMark(item, 'channelName',subAccountIdItem.id)">渠道号：{{ subAccountIdItem.channelName }}</div>
                            <div class='col' :class="setMark(item, 'status',subAccountIdItem.id)">ID使用状态：{{ subAccountIdItem.status==1?'开启':'停用' }}</div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </template>
                  <div class="line"></div>
                  <div class="title-text">其他信息</div>
                  <div :class="setMark(item, 'hasShop',item.platformData.id)">是否有店铺：{{ item.platformData.hasShop==0?'否':'是' }}</div>
                  <template v-if="item.platformData.hasShop==1">
                    <div v-for="(shopItem,shopIndex) in item.platformData.shopList" :key="'shop-'+shopIndex">
                      <div :class="setMark(item, 'shopName',shopItem.id)">店铺{{ makeIndex(shopIndex) }}名称：{{ shopItem.shopName }}</div>
                      <div class="row">
                        <div class='col' :class="setMark(item, 'shopId',shopItem.id)">店铺{{ makeIndex(shopIndex) }}ID：{{ shopItem.shopId }}</div>
                        <div class='col' :class="setMark(item, 'status',shopItem.id)">店铺{{ makeIndex(shopIndex) }}状态：{{ shopItem.status==1?'开启':'停用' }}</div>
                      </div>
                    </div>
                  </template>
                  <div :class="setMark(item, 'remarks',item.platformData.id)">平台账号备注：{{ item.platformData.remarks }}</div>
                </div>
                <div class="btn-more" @click="toggleMore(index)">
                  {{ item.show ? '收起' : '展开' }}
                  <i class="icon el-icon-d-arrow-right"></i>
                </div>
              </div>
            </template>
          </div>
          <!-- <div class='con' v-if="item.type==='change'">
          <div class="title-con">
            <div>
              <span class="title">{{item.title}}</span>
              <span class="name">{{item.name}}</span>
              <div class="time">{{item.time}}</div>
            </div>
            <div>
              <el-button type="primary" class="btn-look" @click="onApproveDetail" plain size="mini">审批详情</el-button>
            </div>
          </div>
          
        </div> -->
        </div>
      </div>
    </el-drawer>
    <pop-process ref="popProcess" />
  </div>
</template>

<script>
import popProcess from "@/pages/assetManagement/common/popProcess";
export default {
  name: "popHistory",
  components: { popProcess, },
  data() {
    return {
      drawer: false,
      timeline: [],
      orderBy: 1,
      orderTitle: '按记录时间顺序',
      type: '',
      myPassword:''
    }
  },
  // activated() {
  //     this.$nextTick(() => {
  //       this.show('workWechat')
  //     })
  // },
  methods: {
    show(type) {
      this.type = type||'workPhone'
      console.log('>>>',type)
      this.timeline = []
      this.fetchData()
      this.drawer = true;
      this.eye = false
    },
    fetchData() {
      const postData = {
        id: this.$route.query.id,
        orderBy: this.orderBy
      };
      let APIURL = this.type+'Log'
      this.$api[APIURL](postData).then(res => {
        if (res.code == 0) {
          if (this.type =='platformAccount') {
            // 平台账号
            this.timeline = res.data.map(item => ({
              ...item,
              show: false,
              // 3:资料变更 修改的属性
              editAttr: item.changeType == 3 && item.attrLogList 
                ? item.attrLogList.map(log => log.attrName +'-'+ log.homeId)
                : []
            }));
            // this.timeline.forEach(item => {
            //   if (item.changeType == 3) {
            //     console.log('被改：',item.editAttr)
            //   }
            // });
          }else{
            // 手机、微信、QQ、邮箱
            this.timeline = res.data.map(item => ({
              ...item,
              show: false,
              // 3:资料变更 修改的属性
              editAttr: item.changeType == 3 && item.attrLogList 
                ? item.attrLogList.map(log => log.attrName)
                : []
            }));
          }
          console.log('timeline：',this.timeline)
        }
      });
    },
    toggleOrder(value) {
      if (this.orderBy == value) return;
      const orderTitles = {
        '1': '按记录时间顺序',
        '2': '按记录时间倒序'
      };
      this.orderBy = value;
      this.orderTitle = orderTitles[value];
      this.fetchData();
    },
    toggleMore(index) {
      const item = this.timeline[index]
      this.$set(this.timeline, index, { ...item, show: !item.show })
    },
    setMark(item, name,id) {
      if (id) {
        let nameAndId = name + '-' + id
        // console.log('setMark>>',item.editAttr,nameAndId)
        return item.editAttr.includes(nameAndId) ? 'hot' : ''
      }else{
        return item.editAttr.includes(name) ? 'hot' : ''
      }
    },
    onApproveDetail(id) {
      this.$refs.popProcess.show(id)
    },
    makeIndex(index){
      return (index + 1).toString().padStart(2, '0')
    },
    onEye(index,item,password){
        if(item.myPassword){
          const item = this.timeline[index]
          this.$set(this.timeline, index, { ...item, myPassword:'' })
        }else{
          this.$api.historyPassword({historyPassword:password}).then(res => { 
              const item = this.timeline[index]
              this.$set(this.timeline, index, { ...item, myPassword:res.data })
          })
        }
        
        
    },
    // 平台账号查看密码
    onEyeAccount(type,index,item,password,subIndex){
      console.log('>>',type,index,item,password,subIndex)
        if (type == 'main') {
        if (item.myPassword) {
            const item = this.timeline[index]
            this.$set(this.timeline, index, { ...item, myPassword:'' })
          }else{
            this.$api.historyPassword({historyPassword:password}).then(res => { 
                const item = this.timeline[index]
                this.$set(this.timeline, index, { ...item, myPassword:res.data||'未设置密码' })
            })
          }
      }
      if (type == 'sub') {
        if (item.platformData.subAccountList[subIndex].myPassword) {
            this.$set(this.timeline[index].platformData.subAccountList[subIndex], 'myPassword', '')
          }else{
            this.$api.historyPassword({historyPassword:password}).then(res => { 
                this.$set(this.timeline[index].platformData.subAccountList[subIndex], 'myPassword', res.data||'未设置密码')
            })
          }
      }
    }
  }
}
</script>
<style lang="scss">
.pop-history {
  border-radius: 8px 0 0 8px;

  .el-drawer__header {
    margin-bottom: 24px;
  }
}
</style>
<style lang="scss" scoped>
.history-order {
  text-align: right;
  color: #2F3030;
  padding: 0 40px 20px 0;

  .hand {
    cursor: pointer;
  }
}

.pop-history {
  .btn-look {
    width: 72px;
    height: 28px;
    padding: 0;
  }

  // 历史记录
  .history-list {
    padding: 0 56px 0 24px;

    .item-history {
      display: flex;
      position: relative;
      padding-bottom: 70px;

      &:not(:last-child)::before {
        content: '';
        position: absolute;
        left: 27px;
        top: 56px;
        bottom: 2px;
        width: 1px;
        background: #00B498;
      }
    }

    .photo {
      display: block;
      width: 54px;
      height: 54px;
      border-radius: 8px;
      background-image: url('~@/assets/def_avatar_84px.png');
      background-size: 100%;
      margin-right: 16px;
      position: relative;

      .i-status {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 38px;
        left: 38px;
        background-size: 100%;
      }

      // 1创建 2转移  3修改 4注销
      .i-1 {
        background-image: url('~@/assets/img/icon/icon_wancheng.png');
      }

      .i-2 {
        background-image: url('~@/assets/img/icon/icon_zhuanjiao.png');
      }

      .i-3 {
        background-image: url('~@/assets/img/icon/icon_xiugai.png');
      }

      .i-4 {
        background-image: url('~@/assets/img/icon/icon_bohui.png');
      }
    }

    .con {
      flex: 1;
    }

    .title-con {
      display: flex;
      justify-content: space-between;
    }

    .title {
      font-weight: 600;
      font-size: 14px;
      color: #2F3030;
      display: inline-block;
      margin-right: 8px;
    }

    .name {
      font-weight: 400;
      font-size: 14px;
      color: #939696;
    }

    .time {
      font-weight: 400;
      font-size: 14px;
      color: #939696;
      margin: 10px 0;
    }

    .content {
      padding: 8px 10px;
      background: #F8FAFA;
      font-weight: 400;
      font-size: 14px;
      line-height: 28px;
      color: #A9ABAB;
      transition: all 0.3s;

      .row {
        display: flex;

        .col {
          flex: 1;
        }
      }

      .hot {
        color: #D6223D
      }

      .more-con {
       display: none;
      }
      .line{
        height: 1px;
        background: #EDF2F2;
        margin: 12px 0;
      }
      .title-text{
        font-weight: bold;
        margin-bottom: 3px;
      }
    }

    .content-open {
      .more-con {
        display: block;
      }

      .btn-more {
        .icon {
          transform: rotate(-90deg);
        }
      }
    }

    .btn-more {
      color: #00B498;
      float: right;
      cursor: pointer;

      .icon {
        transform: rotate(90deg);
        transition: transform 0.3s;
      }
    }

  }

  // 手机状态 1待转移 2已转移 3已注销
  .icon-status {
    font-size: 14px;
    line-height: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    width: 50px;
    height: 24px;
    margin-left: 10px;
  }

  .icon-status-1 {
    color: #939696;
    background-color: #F7F7F7;
  }

  .icon-status-2 {
    color: #00B498;
    background-color: #E4F7F4;
  }

  .icon-status-3 {
    color: #E23C58;
    background-color: #FCE9EC;
  }
  // 眼睛
  .i-eye{
      display: inline-block;
      width: 16px;
      height: 24px;
      background-image: url('~@/assets/img/icon/icon_kejian.png');
      background-repeat: no-repeat;
      background-position: center 5px;
      cursor: pointer;
      position: absolute;
  }
   .eye-con{
     cursor: pointer;
     .text{
      display: inline-block;
      padding-right: 6px;
     }
     .default{
       display:none
     }
   }
  .eye-con-hide{
    cursor: pointer;
    .text{
       display:none
     }
     .default{
      display: inline-block;
      padding-right: 6px;
      line-height: 18px;
      font-size: 16px;
      vertical-align: sub;
     }
    .i-eye{
        background-image: url("~@/assets/img/icon/icon_kejian_hide.png");
        background-position: center 6px;
    }
  }
  
}
</style>